import { hooks } from '@bitrise/bitkit';

const { useMediaQuery } = hooks;

const useMediaQueryAppLayout = (): boolean => useMediaQuery(['1000px'])('1000px');

export default useMediaQueryAppLayout;
